import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import axios from "../../api/axios-allure-docker";
import { redirect } from "../../utility/navigate";

// Подпись поля берёт цвет из темы: жёстко заданный secondary дублировал
// акцент и мешал отличить нормальное состояние от ошибки.
const styles = (theme) => ({
  formLabel: {
    "&.Mui-focused": {
      color: theme.palette.primary.main,
    },
  },
});
class AllureDockerNewProjectDialog extends Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  get initialState() {
    return {
      projectIdTextField: {
        value: "",
        error: false,
        errorMessage: "",
      },
    };
  }

  createProject = () => {
    axios
      // Регистр не трогаем: сервер его сохраняет. toLowerCase() стоял здесь,
      // чтобы сервер не отказал по своей регулярке, — человек вводил EMIAS,
      // получал emias и не понимал, почему скопированный id не работает.
      .post("/projects", {
        id: this.state.projectIdTextField.value,
      })
      .then((response) => {
        this.resetStates();
        this.props.closeNewProjectDialog();
        this.props.getProjects();

        const projectId = response.data.data.id;
        this.props.history.replace(`/projects/${projectId}`);
        // Без toUpperCase: именно из этого тоста id копируют в пайплайн, а
        // заглавная версия сообщала бы id, которого не существует.
        this.props.setAPIAlert("success", `Project ${projectId} created succesfully!`, true);
      })
      .catch((error) => {
        redirect(error);
        this.showProjectIdTextFieldError(error.message);
      });
  };

  handleProjectIdTextFieldChange = (event) => {
    const projectIdTextField = { ...this.state.projectIdTextField };
    projectIdTextField.value = event.target.value;
    this.setState({ projectIdTextField: projectIdTextField });
  };

  showProjectIdTextFieldError = (errorMessage) => {
    const projectIdTextField = { ...this.state.projectIdTextField };
    projectIdTextField.error = true;
    projectIdTextField.errorMessage = errorMessage;
    this.setState({ projectIdTextField: projectIdTextField });
  };

  resetStates = () => {
    this.setState(this.initialState);
  };

  handleCloseDialog = () => {
    this.props.closeNewProjectDialog();
    this.resetStates();
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleCloseDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Create a New Project</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The projects allow you to organize your tests in a better way.
            Use slashes to nest projects into folders, e.g.{" "}
            <code>team/service/suite</code>.
          </DialogContentText>
          <TextField
            error={this.state.projectIdTextField.error}
            value={this.state.projectIdTextField.value}
            autoFocus
            margin="dense"
            id="projectId"
            label="Project ID"
            type="string"
            onChange={this.handleProjectIdTextFieldChange}
            fullWidth
            aria-describedby="component-error-project-id"
            InputLabelProps={{
              className: classes.formLabel,
            }}
          />
          <FormHelperText id="component-error-project-id">
            {this.state.projectIdTextField.errorMessage}
          </FormHelperText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCloseDialog} variant="text">
            Cancel
          </Button>
          <Button onClick={this.createProject} variant="contained" color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles, { withTheme: true })(
  withRouter(AllureDockerNewProjectDialog)
);
